/**
 * Newcop - barra fija "Añadir al carrito" en la ficha de producto (solo movil).
 * Aparece cuando el boton de compra principal ha salido de la pantalla por arriba y abre
 * la hoja de tallas del tema (<atc-bottom-modal>), asi el cliente compra sin volver a subir.
 *
 * Solo se activa si <html> tiene la clase "nc-sticky-atc" (la pone la variante del test VWO:
 *   document.documentElement.classList.add('nc-sticky-atc');
 * ) o si se abre la pagina con ?nc_sticky=1 (para probar; se recuerda en la sesion; ?nc_sticky=0 lo quita).
 * Evento de medicion: dataLayer "nc_sticky_atc_click" y window.VWO evento "ncStickyAtcClick".
 */
(() => {
  if (window.__ncStickyAtc) return;
  window.__ncStickyAtc = true;

  try {
    const p = new URLSearchParams(location.search).get('nc_sticky');
    if (p === '1') sessionStorage.setItem('nc_sticky', '1');
    if (p === '0') sessionStorage.removeItem('nc_sticky');
    if (sessionStorage.getItem('nc_sticky') === '1') document.documentElement.classList.add('nc-sticky-atc');
  } catch (e) {
    /* sin sessionStorage */
  }

  const mq = window.matchMedia('(max-width: 749px)');
  const enabled = () => mq.matches && document.documentElement.classList.contains('nc-sticky-atc');
  let bar = null;
  let mainBtn = null;
  let modal = null;
  let shown = false;

  const findMain = () => {
    const list = document.querySelectorAll('.product__info-container button[name="add"]');
    for (const b of list) {
      if (b.offsetParent !== null && !b.closest('atc-bottom-modal')) return b;
    }
    return null;
  };

  const priceText = () => {
    const el =
      document.querySelector('.product__info-container .price-item--sale.price-item--last') ||
      document.querySelector('.product__info-container .price-item--regular');
    return el ? el.textContent.trim() : '';
  };

  const build = () => {
    const style = document.createElement('style');
    style.textContent =
      '.nc-sticky-atc-bar{position:fixed;left:0;right:0;bottom:0;z-index:40;display:flex;align-items:center;gap:12px;' +
      'padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #e6e6e6;' +
      'box-shadow:0 -4px 16px rgba(0,0,0,.06);transform:translateY(110%);transition:transform .22s ease;}' +
      '.nc-sticky-atc-bar.is-visible{transform:translateY(0);}' +
      '.nc-sticky-atc-bar__info{flex:1 1 auto;min-width:0;line-height:1.25;}' +
      '.nc-sticky-atc-bar__title{display:block;font-size:12px;color:#555;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      '.nc-sticky-atc-bar__price{display:block;font-size:15px;font-weight:600;color:#000;}' +
      '.nc-sticky-atc-bar__btn{flex:0 0 auto;min-height:46px;padding:0 20px;border:0;border-radius:0;background:#000;color:#fff;' +
      'font:inherit;font-size:14px;font-weight:600;cursor:pointer;}' +
      '@media (prefers-reduced-motion: reduce){.nc-sticky-atc-bar{transition:none;}}';
    document.head.appendChild(style);

    const title = (document.querySelector('.product__title h1, h1.product__title, .product__title') || {}).textContent || '';
    bar = document.createElement('div');
    bar.className = 'nc-sticky-atc-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="nc-sticky-atc-bar__info"><span class="nc-sticky-atc-bar__title"></span><span class="nc-sticky-atc-bar__price"></span></div>' +
      '<button type="button" class="nc-sticky-atc-bar__btn" tabindex="-1"></button>';
    bar.querySelector('.nc-sticky-atc-bar__title').textContent = title.trim();
    bar.querySelector('.nc-sticky-atc-bar__btn').textContent = mainBtn.textContent.trim().replace(/\s+/g, ' ');
    bar.querySelector('.nc-sticky-atc-bar__btn').addEventListener('click', () => {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'nc_sticky_atc_click' });
        window.VWO = window.VWO || [];
        window.VWO.push(['event', 'ncStickyAtcClick']);
      } catch (e) {
        /* analytics must never break the page */
      }
      if (modal && typeof modal.open === 'function') {
        modal.open();
      } else {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    document.body.appendChild(bar);
  };

  const update = () => {
    if (!enabled()) {
      if (bar && shown) {
        bar.classList.remove('is-visible');
        shown = false;
      }
      return;
    }
    if (!mainBtn || !mainBtn.isConnected) mainBtn = findMain();
    if (!mainBtn) return;
    if (!modal) modal = document.querySelector('atc-bottom-modal');
    const soldOut = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
    const passed = mainBtn.getBoundingClientRect().bottom < 0;
    const modalOpen = modal && modal.hasAttribute('open');
    const want = passed && !soldOut && !modalOpen;
    if (want && !bar) build();
    if (!bar) return;
    if (want) {
      const price = priceText();
      const el = bar.querySelector('.nc-sticky-atc-bar__price');
      if (el.textContent !== price) el.textContent = price;
    }
    if (want !== shown) {
      bar.classList.toggle('is-visible', want);
      bar.setAttribute('aria-hidden', want ? 'false' : 'true');
      bar.querySelector('.nc-sticky-atc-bar__btn').tabIndex = want ? 0 : -1;
      shown = want;
    }
  };

  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      update();
    });
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('click', () => setTimeout(schedule, 350), true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
